export const clients = [
  {
    id: 1,
    name: 'John Enterprises',
    code: 'C001',
    city: 'New York',
    email: 'john@enterprises.com',
    phone: '123-456-7890',
  },
  {
    id: 2,
    name: 'Delta Traders',
    code: 'C002',
    city: 'Chicago',
    email: 'contact@deltatraders.com',
    phone: '234-567-8901',
  },
  {
    id: 3,
    name: 'Global Solutions',
    code: 'C003',
    city: 'San Francisco',
    email: 'info@globalsolutions.com',
    phone: '345-678-9012',
  },
  {
    id: 4,
    name: 'Skyline Corp',
    code: 'C004',
    city: 'Houston',
    email: 'support@skyline.com',
    phone: '456-789-0123',
  },
  {
    id: 5,
    name: 'Apex Technologies',
    code: 'C005',
    city: 'Seattle',
    email: 'hello@apextech.com',
    phone: '567-890-1234',
  },
  {
    id: 6,
    name: 'Bluewave Inc',
    code: 'C006',
    city: 'Boston',
    email: 'blue@wave.com',
    phone: '678-901-2345',
  },
  {
    id: 7,
    name: 'Vertex Logistics',
    code: 'C007',
    city: 'Atlanta',
    email: 'logistics@vertex.com',
    phone: '789-012-3456',
  },
  {
    id: 8,
    name: 'Northwind Co',
    code: 'C008',
    city: 'Denver',
    email: 'info@northwind.com',
    phone: '890-123-4567',
  },
  {
    id: 9,
    name: 'Prime Networks',
    code: 'C009',
    city: 'Austin',
    email: 'prime@networks.com',
    phone: '901-234-5678',
  },
  {
    id: 10,
    name: 'NextGen Media',
    code: 'C010',
    city: 'Phoenix',
    email: 'contact@nextgenmedia.com',
    phone: '012-345-6789',
  },
];

export const orders = [
  {
    id: 1,
    clientName: 'John Enterprises',
    clientCode: 'C001',
    orderNo: 'O1001',
    orderDate: '2025-08-01',
    direction: 'Inbound',
    totalAmount: '300',
    paidAmount: '00',
    dueAmount: '300',
    paymentMode: 'Cash',
    cashPaid: '00',
    cardPaid: '00',
    remaining: '300',
    receivedAt: '2025-08-01T10:00',
    exitAt: '2025-08-01T12:00',
    status: 'Completed',
    deliveredBy: 'FedEx',
    remarks: 'Delivered on time',
  },
  {
    id: 2,
    clientName: 'Delta Traders',
    clientCode: 'C002',
    orderNo: 'O1002',
    orderDate: '2025-08-02',
    direction: 'Outbound',
    totalAmount: '300',
    paidAmount: '00',
    dueAmount: '300',
    paymentMode: 'Cash',
    cashPaid: '00',
    cardPaid: '00',
    remaining: '300',
    receivedAt: '2025-08-02T09:30',
    exitAt: '2025-08-02T11:00',
    status: 'Pending',
    deliveredBy: 'UPS',
    remarks: 'Waiting for dispatch',
  },
  {
    id: 3,
    clientName: 'Global Solutions',
    clientCode: 'C003',
    orderNo: 'O1003',
    orderDate: '2025-08-03',
    direction: 'Inbound',
    totalAmount: '300',
    paidAmount: '00',
    dueAmount: '300',
    paymentMode: 'Cash',
    cashPaid: '00',
    cardPaid: '00',
    remaining: '300',
    receivedAt: '2025-08-03T13:00',
    exitAt: '2025-08-03T15:30',
    status: 'Completed',
    deliveredBy: 'DHL',
    remarks: 'Client satisfied',
  },
  {
    id: 4,
    clientName: 'Skyline Corp',
    clientCode: 'C004',
    orderNo: 'O1004',
    orderDate: '2025-08-01',
    direction: 'Outbound',
    totalAmount: '300',
    paidAmount: '00',
    dueAmount: '300',
    paymentMode: 'Cash',
    cashPaid: '00',
    cardPaid: '00',
    remaining: '300',
    receivedAt: '2025-08-04T11:00',
    exitAt: '2025-08-04T13:00',
    status: 'Cancelled',
    deliveredBy: 'Local Courier',
    remarks: 'Client cancelled last minute',
  },
  {
    id: 5,
    clientName: 'Apex Technologies',
    clientCode: 'C005',
    orderNo: 'O1005',
    orderDate: '2025-08-01',
    direction: 'Inbound',
    totalAmount: '300',
    paidAmount: '00',
    dueAmount: '300',
    paymentMode: 'Cash',
    cashPaid: '00',
    cardPaid: '00',
    remaining: '300',
    receivedAt: '2025-08-05T10:30',
    exitAt: '2025-08-05T12:45',
    status: 'Completed',
    deliveredBy: 'DHL',
    remarks: 'Delivered earlier than expected',
  },
  {
    id: 6,
    clientName: 'Bluewave Inc',
    clientCode: 'C006',
    orderNo: 'O1006',
    orderDate: '2025-08-01',
    direction: 'Outbound',
    totalAmount: '300',
    paidAmount: '00',
    dueAmount: '300',
    paymentMode: 'Cash',
    cashPaid: '00',
    cardPaid: '00',
    remaining: '300',
    receivedAt: '2025-08-06T14:00',
    exitAt: '2025-08-06T16:00',
    status: 'Pending',
    deliveredBy: 'FedEx',
    remarks: 'Dispatch scheduled',
  },
  {
    id: 7,
    clientName: 'Vertex Logistics',
    clientCode: 'C007',
    orderNo: 'O1007',
    orderDate: '2025-08-01',
    direction: 'Inbound',
    totalAmount: '300',
    paidAmount: '00',
    dueAmount: '300',
    paymentMode: 'Cash',
    cashPaid: '00',
    cardPaid: '00',
    remaining: '300',
    receivedAt: '2025-08-07T08:30',
    exitAt: '2025-08-07T10:15',
    status: 'Completed',
    deliveredBy: 'UPS',
    remarks: 'Delivered without issues',
  },
  {
    id: 8,
    clientName: 'Northwind Co',
    clientCode: 'C008',
    orderNo: 'O1008',
    orderDate: '2025-08-01',
    direction: 'Outbound',
    totalAmount: '300',
    paidAmount: '00',
    dueAmount: '300',
    paymentMode: 'Cash',
    cashPaid: '00',
    cardPaid: '00',
    remaining: '300',
    receivedAt: '2025-08-08T11:45',
    exitAt: '2025-08-08T14:00',
    status: 'Completed',
    deliveredBy: 'Local Courier',
    remarks: 'Left at reception',
  },
  {
    id: 9,
    clientName: 'Prime Networks',
    clientCode: 'C009',
    orderNo: 'O1009',
    orderDate: '2025-08-01',
    direction: 'Inbound',
    totalAmount: '300',
    paidAmount: '00',
    dueAmount: '300',
    paymentMode: 'Cash',
    cashPaid: '00',
    cardPaid: '00',
    remaining: '300',
    receivedAt: '2025-08-09T09:00',
    exitAt: '2025-08-09T11:00',
    status: 'Completed',
    deliveredBy: 'FedEx',
    remarks: 'Client requested call before delivery',
  },
  {
    id: 10,
    clientName: 'NextGen Media',
    clientCode: 'C010',
    orderNo: 'O1010',
    orderDate: '2025-08-01',
    direction: 'Outbound',
    totalAmount: '300',
    paidAmount: '00',
    dueAmount: '300',
    paymentMode: 'Cash',
    cashPaid: '00',
    cardPaid: '00',
    remaining: '300',
    receivedAt: '2025-08-10T10:00',
    exitAt: '2025-08-10T12:00',
    status: 'Pending',
    deliveredBy: 'DHL',
    remarks: 'Urgent delivery',
  },
  {
    id: 11,
    clientName: 'NextGen Media',
    clientCode: 'C010',
    orderNo: 'O1011',
    orderDate: '2025-08-13',
    direction: 'Outbound',
    totalAmount: '300',
    paidAmount: '00',
    dueAmount: '300',
    paymentMode: 'Cash',
    cashPaid: '00',
    cardPaid: '00',
    remaining: '300',
    receivedAt: '2025-08-10T10:00',
    exitAt: '2025-08-10T12:00',
    status: 'Pending',
    deliveredBy: 'DHL',
    remarks: 'Urgent delivery',
  },
];

export const fieldLabels = {
  clientName: "Client Name",
  clientCode: "Client Code",
  orderNo: "Order Number",
  orderDate: "Order Date",
  direction: "Direction",
  totalAmount: "Total Amount",
  paidAmount: "Paid Amount",
  dueAmount: "Due Amount",
  paymentMode: "Payment Mode",
  remarks: "Remarks",
  cashPaid: "Cash Payment",
  cardPaid: "Card Payment",
  remaining: "Remaining",
  paymentDate: "Payment Date",
};

// export default {clients, orders}